import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import Select from 'react-select';
import { RegisterContext } from '../../contexts/RegisterContext';
import * as referenceService from '../services/referenceService';
import Swal from 'sweetalert2';
import { ChildReportExcell } from '../../utils/DrawExcell';
import { translateKeys } from '../../Shared/Translate';
import { Statuses } from '../../Shared/statuses';
import { Button } from 'primereact/button';
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import { MobileContext } from '../../contexts/MobileContext';

export function AdminRankedChildrens() {
    const { user } = useContext(AuthContext);
    const { schools, commonAdvantages, advantages } = useContext(RegisterContext);

    const [loading, setLoading] = useState(false);
    const [selectedSchool, setSelectedSchool] = useState(user.role == 'Director' ? { value: user.school.id } : null);
    const [resultData, setResultData] = useState([]);
    const [childrenExcell, setChildrenExcell] = useState([]);
    const { isOnMobile } = useContext(MobileContext);

    const [errmsg, setErrmsg] = useState(null);

    document.title = `Класирани деца`;

    const convertedData = schools.map(item => ({
        value: item.id,
        label: item.shortName
    }));

    const addInfo = {
        value: 0,
        label: 'Всички училища'
    }

    convertedData.unshift(addInfo);


    const handleChange = (selectedSchool) => {
        setSelectedSchool(selectedSchool);
    };

    const populate = async () => {

        try {
            await referenceService.getSchoolRanking(1, selectedSchool.value)
                .then((res) => {
                    if (res.status !== 400) {
                        setResultData(res);
                        if (res.length === 0) {
                            setErrmsg('Не са открити деца по тези критерии');
                        }
                    }
                })
        } catch (error) {


            if (error.message === 'Няма активно класиране!') {
                setErrmsg('Няма активно класиране!');
            }
            //console.error('Error fetching data:', error.message);
        }
    };

    const getpdf = async () => {

        try {
            setLoading(true)
            await referenceService.getPdfRanking(selectedSchool.value)
                .then((res) => {
                    if (res.status !== 400) {
                        if (res) {
                            setLoading(false)
                            if (res) {
                                if (isOnMobile) {
                                    const link = document.createElement('a');
                                    link.href = res;
                                    link.download = 'document.pdf';
                                    link.click();
                                } else {
                                    const newTab = window.open(res, '_blank');
                                    if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                                        console.error('Error: The browser blocked opening a new tab.');
                                        Swal.fire({
                                            title: 'Браузърът блокира отварянето на PDF файла.',
                                            text: 'Проверете настройките на браузъра си за поверителност и сигурност(Privacy & Security.),за Chrome: Изскач. прозорци и пренасочвания(Pop-ups and Redirects), за Mozilla: Разрешения(Permissions)',
                                            icon: 'error',
                                            confirmButtonText: 'ОК'
                                        })
                                    }
                                }
                            }
                        }
                    }
                    else {
                        if (res) {
                            if (isOnMobile) {
                                    const link = document.createElement('a');
                                    link.href = res;
                                    link.download = 'document.pdf';
                                    link.click();
                                } else {
                                    const newTab = window.open(res, '_blank');
                                    if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                                        console.error('Error: The browser blocked opening a new tab.');
                                        Swal.fire({
                                            title: 'Браузърът блокира отварянето на PDF файла.',
                                            text: 'Проверете настройките на браузъра си за поверителност и сигурност(Privacy & Security.),за Chrome: Изскач. прозорци и пренасочвания(Pop-ups and Redirects), за Mozilla: Разрешения(Permissions)',
                                            icon: 'error',
                                            confirmButtonText: 'ОК'
                                        })
                                    }
                                }
                        }

                        Swal.fire({
                            title: 'Внимание!',
                            text: res.message,
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })

                        setLoading(false)
                    }
                })
        } catch (error) {
            Swal.fire({
                title: 'Внимание!',
                text: error.message,
                icon: 'error',
                confirmButtonText: 'ОК'
            })

            setLoading(false)
        }
    };

    useEffect(() => {
        populate();
    }, [selectedSchool]);

    const downloadExcell = (e) => {
        e.preventDefault()

        setLoading(true)

        if (!selectedSchool) {
            Swal.fire({
                title: 'Внимание!',
                text: 'Изберете училище!',
                icon: 'error',
                confirmButtonText: 'ОК'
            })

            setLoading(false)

            return
        }

        referenceService.getChildReportExcell(selectedSchool.value)
            .then((children) => {
                const obj_keys = Object.keys(children[0]);
                let headers = obj_keys;
                
                let cols = [];
                let headersBg = [];;

                for (let kid of children) {
                    headersBg.push(translateKeys(kid));
                }

                headersBg = headersBg.map(x => {
                    for (var key in x) {
                        if (key.includes('П') && x[key] == 0) {
                            x[key] = '';
                        }
                    }

                    return {
                        ...x,
                        Статус: Statuses[x.Статус]
                    }
                })

                cols = headers.map((header, index) => {
                    if (header == 'regnumbeR_ID') {
                        return {
                            width: 8,
                        };
                    } else if (header == 'chilD_EGN' || header == 'parenT_PHONE') {
                        return {
                            width: 14,
                        };
                    } else if (header == 'grupA_RESIDENCE') {
                        return {
                            width: 12,
                        };
                    } else if (header == 'addresS_C_TXT' || header == 'addresS_P_TXT') {
                        return {
                            width: 40,
                        };
                    } else if (header.length > 4) {
                        return {
                            width: 30,
                        };
                    } else {
                        return {
                            width: 5,
                        };
                    }

                });



                ChildReportExcell(headersBg, selectedSchool.label, cols, [headersBg], commonAdvantages, advantages)
                setLoading(false)
            })
            .catch((err) => {
                Swal.fire({
                    title: 'Внимание!',
                    text: err.message,
                    icon: 'error',
                    confirmButtonText: 'ОК'
                })
                setLoading(false)
            })


    }

    return (
        <main id="main" className="main">
            <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />
            <div className="pagetitle">
                <h1 className="use-font">Класирани деца</h1>


                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Класирани деца</li>
                    </ol>

                </nav>



            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">
                        <div className="row d-flex flex-wrap gap-3">
                            {(user.role === 'SuperAdmin' || user.role === 'Municipality' || user.role === 'Admin') ?
                                <div className="col-lg-2  d-flex flex-wrap w-30 w-70-l justify-content-between w-100-mob gap-2">
                                    <h3 className="w-100">Избери училище</h3>
                                    <Select
                                        value={selectedSchool}
                                        onChange={handleChange}
                                        options={convertedData}
                                        placeholder="Избери"
                                        className="w-50 w-100-mob"
                                    />
                                    <Button
                                        label="Изтегли Excell"
                                        icon="pi pi-file-excel"
                                        severity="danger"
                                        raised
                                        className='btn-prim-confirm w-35  w-100-mob m-0-mob'
                                        onClick={downloadExcell}
                                    />
                                </div>
                                : ''
                            }
                            {user.role === 'Director' &&
                                <>
                                    <Button
                                        label="Списък класирани (без лични данни)"
                                        icon="pi pi-file-pdf"
                                        severity="danger"
                                        raised
                                        className='btn-prim-red w-25 ml-06 w-100-mob m-0-mob w-40-l'
                                        onClick={() => getpdf()}
                                    />
                                    <Button
                                        label="Изтегли Excell"
                                        icon="pi pi-file-excel"
                                        severity="danger"
                                        raised
                                        className='btn-prim-confirm w-15 w-100-mob m-0-mob w-30-l'
                                        onClick={downloadExcell}
                                    />
                                </>
                            }

                        </div>
                        
                        <div className="row mt-5">
                            {(selectedSchool && resultData.length > 0) ?
                                <table className="table table-striped table-hover w-100">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Рег.Номер</th>
                                            <th scope="col">ЕГН/ЛНЧ</th>
                                            <th scope="col">ИМЕ</th>
                                            <th scope="col">УЧИЛИЩЕ</th>
                                            <th scope="col">СТАТУС</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {

                                            resultData.map((r, index) => (
                                                <tr key={index + 1}>
                                                    <td>{index + 1}</td>
                                                    <td>{r.regnumbeR_ID}</td>
                                                    <td>{r.childEgn}</td>
                                                    <td>
                                                        {r.childName}
                                                        {r.childName2 && <br />}
                                                        {r.childName2}
                                                        {r.childName3 && <br />}
                                                        {r.childName3}
                                                        {r.childName4 && <br />}
                                                        {r.childName4}
                                                    </td>
                                                    <td>{r.schools[0]}</td>
                                                    <td>Класирани деца</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                                : errmsg
                            }
                        </div>
                    </div>

                </div>

            </section>

        </main>
    )
}

export default AdminRankedChildrens;